<template>
  <div class="settings-view-time">
    <a-alert
      class="setting__aleter"
      message="注意"
      description="从较小的块大小（15分钟）切换到大的块大小（30分钟）后，若修改记录会导致较小块的记录被较大块的记录覆盖"
      type="warning"
      show-icon
    />
    <a-form-model layout="vertical" ref="form" :model="block">
      <a-form-model-item label="块大小" :required="false">
        <a-select v-model="block.size" @change="updateSetting">
          <a-select-option value="15">15分钟</a-select-option>
          <a-select-option value="30">30分钟</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="块显示字段" :required="false">
        <div>
          <a-checkbox-group
            v-model="block.showField"
            :options="plainOptions"
            @change="updateSetting"
          />
        </div>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
// import AvatarModal from './AvatarModal'
import { mapActions, mapGetters } from "vuex";
// const mapShowField = {
//   ["分类名"]: "category",
//   ["事件图标"]: "icon",
//   ["事件名"]: "event",
//   ["事件缩写"]: "abbr"
// };
const plainOptions = [
  { label: "分类名", value: "category.name" },
  { label: "事件图标", value: "event.icon" },
  { label: "事件名", value: "event.name" },
  { label: "事件缩写", value: "event.abbr" }
];
export default {
  // components: {
  //   AvatarModal
  // },
  data() {
    return {
      block: {
        size: "15",
        showField: []
      },
      plainOptions
    };
  },
  computed: {
    ...mapGetters(["setting"])
  },
  mounted() {
    const setting = this.setting;
    for (let key in this.block) {
      this.block[key] = setting.block[key];
    }
  },
  methods: {
    updateSetting() {
      this.setOption({ key: "block", option: this.block });
    },
    onChange(checkedList) {
      console.log(checkedList.length, this.block.showField);
    },
    ...mapActions(["setOption"])
  }
};
</script>
<style scoped>
.setting__aleter {
  margin-bottom: 2rem;
}
</style>
